export default RAILS_ASSET_URL("/before-after-engine-bay-after.webp")
